import "./News.scss";
import axios from "axios";
import ActivitySwitch from "@/components/Common/ActivitySwitch/ActivitySwitch.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getTokenHeader } from "@/helpers/commonHelper";
import { loadConfig, createError } from "@/helpers/newsHelper";

import NewsAppStatistics from "@/components/News/NewsAppStatistics/NewsAppStatistics.vue";
import NewsAppPushMessagesNotification from "@/views/News/NewsAppPushMessagesNotification/NewsAppPushMessagesNotification.vue";

export default {
  name: "News",
  components: {
    NewsAppPushMessagesNotification,
    NewsAppStatistics,
    ActivitySwitch
  },
  data() {
    return {
      statisticData: {},
      lastNews: [],
      ignoreUser: false,
      statistic: {},
      config: {},
      availableNewsForAppPushMessage: []
    };
  },
  async mounted() {
    await this.$store.dispatch("getCurrentUser");
    await this.$store.dispatch("getAllUsers");
    await this.loadStatistics();
    await this.loadConfig();
    if (this.isAdmin || this.userCanSendPushMessages) {
      this.$nextTick(() => {
        this.getAvailableNewsForAppPushMessage(
          this.$refs.newsAppPushMessagesNotification?.maxNumberOfSuggestions
        );
      });
    }
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    users() {
      return this.$store.state.users ?? [];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal?.id;
    },
    isNewsEditor() {
      return (
        this.isNewsAdmin ||
        this.$store.state.currentUser?.scopes.includes("role:news_editor")
      );
    },
    isNewsAdmin() {
      return (
        this.isAdmin ||
        this.$store.state.currentUser?.scopes.includes("role:news_admin")
      );
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isExternNewsEditor() {
      return this.$store.state.currentUser?.scopes?.includes(
        "role:extern_news_editor"
      );
    },
    userCanSendPushMessages() {
      return this.$store.state.currentUser?.scopes.includes(
        "role:news_app_push_messages"
      );
    },
    appdinxLogin() {
      return this.$store.state.selectedPrincipal?.additional_data?.appdinxLogin;
    }
  },
  methods: {
    loadConfig,
    createError,
    async loadStatistics() {
      this.statistic = await this.getStatisticData(this.ignoreUser);
      this.lastNews = this.statistic?.last_news;
    },
    async getStatisticData() {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal,
        ignoreUser: this.ignoreUser ? 1 : 0
      };
      try {
        const result = await axios.get(
          `${env.news_api_client_url}news/statistics`,
          {
            params,
            headers
          }
        );
        return result.data;
      } catch (err) {
        this.createError(err);
      }
    },
    goTo(path) {
      this.$router.push(path);
    },
    getUserAvatar(updatedBy) {
      let user = this.users?.find(user => user._id === updatedBy);
      if (!user && this.user?._id === updatedBy) {
        user = this.user;
      }
      return user?.avatar_uri || "";
    },
    async getAvailableNewsForAppPushMessage(limit) {
      this.availableNewsForAppPushMessage = null;

      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const response = await axios.get(
          env.news_api_client_url +
            "app_push_message/available-news" +
            (limit ? `?limit=${limit}` : ""),
          {
            params,
            headers
          }
        );
        this.availableNewsForAppPushMessage = response.data;
      } catch (error) {
        await this.createError(error);
        this.availableNewsForAppPushMessage = null;
      }
    }
  }
};
